export default __webpack_public_path__ + "static/media/image_4.fafe34b1.jpg";